/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ResolvedRecords } from "./ResolvedRecords";
export const UpdateResolutionRequest = core.serialization.object({
    resolvedRecords: core.serialization.list(ResolvedRecords),
});
